import { FC, useMemo } from 'react';

import { StyledTextField } from 'components';

import { useAuth } from 'contexts/auth';
import useTimeZone from 'hooks/use-timezone';
import { Role } from 'types';
import { useNewTransaction } from '../new-transaction.context';

const GeneralInformation: FC = () => {
  const { transaction, updateTransaction } = useNewTransaction();
  const { userProfile } = useAuth();
  const { dateTimeLocalToUtc, newZonedDayJs, utcToZonedDateTimeLocal } = useTimeZone();

  const numRows = useMemo(() => 1 + Number([Role.ADMIN, Role.BILLING_ADMIN].includes(userProfile.role)), [userProfile.role]);

  return (
    <div className="card-primary">
      <div className="card-header px-3">
        <h4>GENERAL INFORMATION</h4>
      </div>
      <div className="card-body grid-3">
        <div className="p-relative">
          <input className="w-100" disabled />
          <label className="search">CONTRACT</label>
        </div>
        <div className={`col-span-2 row-span-${numRows} h-100`}>
          <StyledTextField
            className="h-100"
            InputProps={{ className: 'h-100' }}
            fullWidth
            multiline
            label="NOTES"
            value={transaction.notes ?? ''}
            onChange={e => updateTransaction({ notes: e.target.value })}
            data-cy="transaction-notes-input"
          />
        </div>
        {[Role.ADMIN, Role.BILLING_ADMIN].includes(userProfile.role) && (
          <div className="d-flex date-field">
            <input
              type="datetime-local"
              className="w-100"
              onChange={e => {
                updateTransaction({ completedDate: dateTimeLocalToUtc(e.target.value) });
                if (newZonedDayJs(e.target.value).isAfter(newZonedDayJs())) {
                  e.target.setCustomValidity('Forward dated transactions are not allowed');
                } else {
                  e.target.setCustomValidity('');
                }
              }}
              value={utcToZonedDateTimeLocal(transaction.completedDate ?? undefined)}
              disabled={!transaction.completedDate}
              required
            />
            <button
              className="btn-close"
              type="button"
              onClick={() =>
                updateTransaction({
                  completedDate: transaction.completedDate ? undefined : newZonedDayJs().toISOString()
                })
              }
            >
              <span className="material-icons icon-large">{transaction.completedDate ? 'lock_open' : 'lock'}</span>
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

export default GeneralInformation;
